import config from 'src/config'
import isNode from 'is-node'

const { imageSizes } = config

const webpSupport = () => {
  if (!isNode && document) {
    return document.body.classList.value.includes('support-webp')
  } else {
    return false
  }
}

export function getContentfulSrcSet(url: string) {
  const srcSet: { [key: string]: string } = {}
  const webpString = webpSupport() ? '&fm=webp' : ''
  imageSizes.forEach((size: number) => {
    if (size > 1000) {
      srcSet[size] = `${url}?w=${size}&q=80${webpString}`
    } else if (size > 100) {
      srcSet[size] = `${url}?w=${size}${webpString}`
    }
  })
  return srcSet
}
